// extracted by mini-css-extract-plugin
export default {"ad-banner":"ad-banner__em7sx"};